import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';
import { ProdutoViewPage } from '../../pages/produto-view/produto-view';
import { SemovelProvider } from '../../providers/semovel/semovel';

@Component({
  selector: 'home-card-produto',
  templateUrl: 'home-card-produto.html',
})
export class HomeCardProdutoComponent {
  @Input() produto;

  constructor(private navCtrl:NavController, private server:SemovelProvider) {
  }

  
  visualizarProduto(produto){
    this.navCtrl.push(ProdutoViewPage, {
      produto: produto
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/home-card-produto/home-card-produto.ts